import { Typography, Avatar } from '@douyinfe/semi-ui';
import { Rightarrow, Smile, User } from '@okee-fe/react-icons-dy-open';
import { useHistory } from '@jupiter/plugin-runtime/router';
import cls from 'classnames';
import style from './index.module.scss';
import { useUserInfo } from '@/hooks/useUserInfo';
import { useUserHome } from '@/hooks/useUserHome';

type UserCardProps = {
  title: string;
  num?: number;
  userId?: string;
};

const UserCard = ({ title, num = 0, userId }: UserCardProps) => (
  <div
    className={cls(
      style.hoverChildrenPrimary,
      'flex flex-col py-4 pl-4 border w-full rounded-md hover:border-semi-color-primary hover:text-semi-color-primary hover:cursor-pointer',
    )}
    onClick={() => {
      window.open(`${window.location.origin}/forum/user/${userId || ''}`);
    }}>
    <Typography.Text type="tertiary">{title}</Typography.Text>
    <Typography.Title heading={4} strong={true} className={'mt-[2px]'}>
      <span className="text-2xl font-bold">{num}</span>
    </Typography.Title>
  </div>
);

const toLogin = () => {
  window.Garfish.channel.emit('main:login-activate');
};

export const UserHome = () => {
  const { User: currentUser, ifLogin } = useUserInfo();
  const history = useHistory();
  const { data } = useUserHome();

  const toUserHome = () => {
    history.push(`/user/${currentUser?.Id || ''}`);
  };

  return (
    <div
      className="bg-white rounded-xl px-8 py-6"
      style={{
        maxWidth: '400px',
        width: '100%',
      }}>
      <div className="flex justify-between  ">
        <div>
          <Typography.Title heading={6} className="flex items-center">
            {ifLogin ? (
              <>
                {currentUser?.Avatar ? (
                  <Avatar className="w-7 h-7 mr-2" src={currentUser.Avatar} />
                ) : (
                  <User className="w-7 h-7 mr-2" />
                )}

                {currentUser?.Name}
              </>
            ) : (
              <>
                <Smile className="w-7 h-7 mr-2" />
                欢迎来到开发者社区
              </>
            )}
          </Typography.Title>
        </div>
        <div
          className="flex items-center hover:cursor-pointer"
          onClick={() => {
            if (ifLogin) {
              toUserHome();
            } else {
              toLogin();
            }
          }}>
          <Typography.Text type="tertiary">
            {ifLogin ? '个人中心' : '去登录'}
          </Typography.Text>
          <Rightarrow />
        </div>
      </div>
      <div className="flex space-x-3 mt-6">
        <UserCard
          title="提问"
          num={Number(data?.UserSummary?.Question || 0)}
          userId={currentUser?.Id}
        />
        <UserCard
          userId={currentUser?.Id}
          title="评论"
          num={
            Number(data?.UserSummary?.Reply || 0) +
            Number(data?.UserSummary?.Comment || 0)
          }
        />
      </div>
      <div className="flex space-x-3 mt-3">
        <UserCard
          userId={currentUser?.Id}
          title="文章"
          num={Number(data?.UserSummary?.Share || 0)}
        />
        <UserCard
          userId={currentUser?.Id}
          title="我的收藏"
          num={Number(data?.UserSummary?.Collected || 0)}
        />
      </div>
    </div>
  );
};
